import { AxiosResponse } from 'axios';
import { APIResponse } from '../Helper/type';
import IDeactivate from './Deactivate.interface';
import { handleApiResponse } from '../Helper/apiResponseHandler';
import apiCallWrapper from '../../apiwrapper/apiCallWrapper';

// Declaring the web server path
const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');
export default class DeactiveAdmin {
  public apiResponse: APIResponse | undefined;

  // Declaring the constructor to get the request body. This constructor is of type IOrgUser
  constructor(public userInfo: IDeactivate) {}

  // Declaring the sub-path
  public subPath: string = `/organization/admin/${this.userInfo.email}`;

  // POST request for creating Organization Users and storing it to db. This methods returns a response body along with a status code.
  public async deactivateAdmin(): Promise<APIResponse> {
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(this.subPath, 'PATCH');
      const url: string = this.createUrl(this.subPath);
      const requestBody: IDeactivate = this.userInfo;
      const response: AxiosResponse<any, any> = await axiosWithRoles.patch(url, requestBody);
      const errorMessage = '';
      const successMessage = response.data.message;
      this.apiResponse = handleApiResponse(response.status, errorMessage, successMessage);
    } catch (error: any) {
      switch (error?.response?.status) {
        case 406:
          this.apiResponse = {
            statusCode: 406,
            body: 'User already exists in the Database'
          };
          break;
        default:
          this.apiResponse = { statusCode: 500, body: JSON.stringify(error) };
      }
    }
    return this.apiResponse;
  }

  // Binding the Webserver path and sub-path

  private createUrl(params?: string): string {
    return backEndServerUrl + params;
  }
}
